function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* Copyright (C) 2018 TeselaGen Biotechnology, Inc. */
import React, { useMemo, useRef } from "react";
import { Dialog, useHotkeys } from "@blueprintjs/core";
import { noop, isFunction } from "lodash";
import { ResizableDraggableDialog } from "."; // eslint-disable-next-line import/no-anonymous-default-export

export default (function (topLevelDialogProps) {
  if (topLevelDialogProps === void 0) {
    topLevelDialogProps = {};
  }

  return function (Component) {
    return function (props) {
      var r = useRef();
      var memoedHotkeys = useMemo(function () {
        return [{
          combo: topLevelDialogProps.useCmdEnter ? "cmd+enter" : "enter",
          global: true,
          allowInInput: true,
          onKeyDown: function onKeyDown() {
            function doNotTriggerClick() {//leave this here for debugging purposes
              // console.log(`Not triggering dialog submit`);
            }

            try {
              var _r$current;

              // eslint-disable-next-line no-inner-declarations
              var triggerClick = function triggerClick() {
                parentEl == null ? void 0 : parentEl.querySelector("button[type='submit']").click();
              };

              if (!document.activeElement) return doNotTriggerClick();

              if (!document.activeElement.closest(".tg-allow-dialog-form-enter")) {
                //don't do this if you're in any type of bp multi select by default
                if (document.activeElement.closest(".bp3-multi-select")) return doNotTriggerClick(); //don't do this if there is an explicit class saying not to

                if (document.activeElement.closest(".tg-stop-dialog-form-enter")) return doNotTriggerClick(); //don't do this in text areas

                if (document.activeElement.type === "textarea") return doNotTriggerClick();
              }

              var parentEl = (_r$current = r.current) == null ? void 0 : _r$current.closest(".bp3-dialog-container");
              var dialogs = document.querySelectorAll(".bp3-dialog-container");
              var numDialogs = dialogs == null ? void 0 : dialogs.length;

              if (numDialogs > 1) {
                var topMostDialog = dialogs[numDialogs - 1];

                if (topMostDialog === parentEl) {
                  triggerClick();
                }
              } else {
                //just 1 dialog
                triggerClick();
              }
            } catch (error) {
              console.error("error:", error);
            }
          }
        }];
      }, []);
      useHotkeys(memoedHotkeys);
      var otherTopLevelProps,
          getDialogProps = noop;

      if (isFunction(topLevelDialogProps)) {
        getDialogProps = topLevelDialogProps;
      } else {
        var _topLevelDialogProps = topLevelDialogProps,
            footerProps = _topLevelDialogProps.footerProps,
            _pullOff = _topLevelDialogProps.getDialogProps,
            additionalProps = _objectWithoutPropertiesLoose(_topLevelDialogProps, ["footerProps", "getDialogProps"]);

        otherTopLevelProps = additionalProps;
        getDialogProps = topLevelDialogProps.getDialogProps || noop;
      }

      var dialogProps = props.dialogProps,
          hideModal = props.hideModal,
          otherProps = _objectWithoutPropertiesLoose(props, ["dialogProps", "hideModal"]);

      var extraDialogProps = _extends({}, otherTopLevelProps, dialogProps, getDialogProps(props));

      var DialogToUse = extraDialogProps.isDraggable ? ResizableDraggableDialog : Dialog;
      return /*#__PURE__*/React.createElement(DialogToUse, _extends({
        canOutsideClickClose: false,
        isOpen: true,
        onClose: hideModal
      }, extraDialogProps, {
        style: _extends({}, extraDialogProps.style)
      }), /*#__PURE__*/React.createElement("div", {
        ref: r
      }), /*#__PURE__*/React.createElement(Component, _extends({
        hideModal: hideModal
      }, otherProps)));
    };
  };
});